import * as ActionTypes from '../../actions/allActions'
import { bookingNormalizer } from '../../normalizers/Normalizers'

const bookingsInit = { past: [], future: [] }
const bookings = (state = bookingsInit, action) => {
	switch (action.type) {
		case ActionTypes.FETCHFUTUREBOOKINGS_SUCCESS:
			return { ...state, future: [ ...state.future, ...action.data.data.map(b => bookingNormalizer(b)) ] }
		case ActionTypes.FETCHPASTBOOKINGS_SUCCESS:
			return { ...state, past: [ ...state.past, ...action.data.data.map(b => bookingNormalizer(b)) ] }
		case ActionTypes.SUBMITREVIEW_SUCCESS:
			return { ...state, past: state.past.map(b => b.id !== action.data.data.id ? b : bookingNormalizer(action.data.data)) }
		case ActionTypes.RESET_BOOKINGS_STATE:
		case ActionTypes.LOGOUT:
			return bookingsInit
		default:
			return state
	}
}

export default bookings



// WEBPACK FOOTER //
// ./src/reducers/data/bookings.js